import SplashScreen from "./components/SplashScreen";
import Registration from "./components/Registration";
import Login from "./components/Login";
import Resetpassword from "./components/Resetpassword";
import RegesterAdmin from "./components/RegesterAdmin";
import ProjectInfo from "./components/ProjectInfo";
import Reset from "./components/resetpassword/Reset";
import Dashboard from "./components/Dashboard";
import LabDashboard from "./components/LabDashboard";
import MtcLabDashboard from "./kit-two/components/MtcLabDashboard";
import SkuDetail from "./components/dashboard/SkuDetail";
import KitIdAlert from "./components/dashboard/KitIdAlert";
import DownloadReport from "./components/DownloadReport";
import Home from "./components/Home";
import V2Dashboard from "./kit-two/views/Dashboard";
import V2AdminDashboard from "./kit-two/views/AdminDashboard";
import V2ProjectInfo from "./kit-two/views/ProjectInfo";
import store from "./store/store.js";
import registrationstore from "./store/modules/registration.js";
import CryptoJS from 'crypto-js';
import axios from "axios";
import Verification from "./components/registration/Verfication";


export const routes = [
  {
    path: "/activate",
    component: Registration,
    name: "Registration",
    beforeEnter: async (to, from, next) => {
      let searchParams = new URLSearchParams(window.location.search);
      if(searchParams.has('tid')) {
        const encrypted = atob(searchParams.get('tid'));
        let originalText  = CryptoJS.AES.decrypt(encrypted, 'GmOKTPswDt6h{at62@32.RDPrdss8@SS').toString(CryptoJS.enc.Utf8);
        originalText = originalText.replace(/-/g, "");
        originalText = originalText.toUpperCase();
        let message = "";

        try {
          let response = await axios.post("/v1/customer/testkitsValidation", {"kit_id":originalText})
          message = response.data.data;
        }catch(error){
          if(error.response.data.error == 'ValidationException'){
            if(!error.response.data.data.messages.success){
              message = error.response.data.data.messages.errors[0].message;
            }
          }
        }

        if(message == "kit_id_exist") {
          localStorage.setItem("actkitid", originalText);
          next("/get-started");
        }else {
          next({name: 'KitIdAlert', params:{message:message,kit_id:originalText}})
        }
      }else {
        if(localStorage.getItem("ctoken")) {
          store.commit("back", false);
          store.dispatch("profile");
        }
        if(from.path === "/" && to.query.step) {
          store.commit("back", false);
          store.dispatch("clearToken");
          next("/login");
        }else {
          next();
        }
      }
    }
  },
  {
    path: "/",
    beforeEnter: async (to, from, next) => {
      let searchParams = new URLSearchParams(window.location.search);
      if(searchParams.has('tid')){
        const encrypted = atob(searchParams.get('tid'));
        let originalText  = CryptoJS.AES.decrypt(encrypted, 'GmOKTPswDt6h{at62@32.RDPrdss8@SS').toString(CryptoJS.enc.Utf8);
        originalText = originalText.replace(/-/g, "");
        originalText = originalText.toUpperCase();
        let message = "";

        try {
          let response = await axios.post("/v1/customer/testkitsValidation", {"kit_id":originalText})
            message = response.data.data;
        }catch (error) {
          if(error.response.data.error == 'ValidationException'){
            if(!error.response.data.data.messages.success){
              message = error.response.data.data.messages.errors[0].message;
            }
          }
        }

        if(message == "kit_id_exist") {
            localStorage.setItem("actkitid", originalText);
            next("/get-started");
        }else {
          next({name: 'KitIdAlert', params:{message:message,kit_id:originalText}})
        }
      } else {
        if (localStorage.getItem("atoken")) {
          store.dispatch("setAdminToken", localStorage.getItem("atoken"));
          store.commit("back", false);
          next("/dashboard");
        } else if (sessionStorage.getItem("atoken")) {
          store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
          store.commit("back", false);
          next("/dashboard");
        } else if (localStorage.getItem("ctoken")) {
          store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
          store.commit("back", false);
          store.dispatch("getUser").then(res => {
            next("/home");
          });
        } else if (sessionStorage.getItem("ctoken")) {
          store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
          store.commit("back", false);
          store.dispatch("getUser").then(res => {
            next("/home");
          });
        } else {
          next("/get-started");
        }
      }
    }
  },
  {
    path: "/KitIdAlert",
    component: KitIdAlert,
    props:true,
    name: "KitIdAlert",
  },
  {
    path: "/get-started",
    component: SplashScreen,
    name: "GetStarted",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.commit("back", false);
        next("/dashboard");
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.commit("back", false);
        next("/dashboard");
      } else if (localStorage.getItem("ctoken")) {
        store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        store.commit("back", false);
        store.dispatch("getUser").then(res => {
          next("/home");
        });
      } else if (sessionStorage.getItem("ctoken")) {
        store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        store.commit("back", false);
        store.dispatch("getUser").then(res => {
          next("/home");
        });
      } else {
        next();
      }
    }
  },
  {
    path: "/login",
    component: Login,
    name: "Login",
    beforeEnter: (to, from, next) => {
      if (from.path === "/activate") {
        store.dispatch("clearToken");
      }
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.commit("back", false);
        next("/dashboard");
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.commit("back", false);
        next("/dashboard");
      } else if (localStorage.getItem("ctoken")) {
        store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        store.commit("back", false);
        store.dispatch("getUser").then(res => {
          next("/home");
        });
      } else if (sessionStorage.getItem("ctoken")) {
        store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        store.commit("back", false);
        store.dispatch("getUser").then(res => {
          next("/home");
        });
      } else {
        next();
      }
    }
  },
  { path: "/resetpassword", component: Resetpassword, name: "Resetpassword" },
  {
    path: "/admin/invintation",
    component: RegesterAdmin,
    name: "RegesterAdmin",
    beforeEnter: (to, from, next) => {
      if (to.query.email) {
        if (localStorage.getItem("ctoken") || localStorage.getItem("atoken")) {
          store.dispatch("clearToken").then(res => {
            next();
          });
        } else if (sessionStorage.getItem("ctoken") || localStorage.getItem("atoken")) {
          store.dispatch("clearToken").then(res => {
            next();
          });
        } else {
          next();
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/password/restore",
    component: Reset,
    name: "Reset"
  },
  {
    path: "/dashboard",
    component: Dashboard,
    name: "Dashboard",
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/dashboard-v2",
    component: V2AdminDashboard,
    name: "DashboardV2",
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/sku/:sku",
    component: SkuDetail,
    name: "SkuDetail",
    props: true,
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/dashboard/sku/:sku",
    component: SkuDetail,
    name: "DashboardSkuDetail",
    props: true,
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getAdminInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/lab/dashboard",
    component: LabDashboard,
    name: "Lab Dashboard",
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getLabOperatorInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        store.dispatch("setDetails",false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getLabOperatorInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/mtclab/dashboard",
    component: MtcLabDashboard,
    name: "MtcLab Dashboard",
    beforeEnter(to, from, next) {
      if (localStorage.getItem("atoken")) {
        store.dispatch("setAdminToken", localStorage.getItem("atoken"));
        store.dispatch("getMtcLabInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else if (sessionStorage.getItem("atoken")) {
        store.dispatch("setAdminTokenSession", sessionStorage.getItem("atoken"));
        store.dispatch("getMtcLabInfo");
        store.commit("saveRole", localStorage.getItem("role"));
        store.commit("back", false);
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/home",
    component: Home,
    name: "Home",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("ctoken")) {
        store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        store.commit("back", false);
        store.commit("setDetails",false);
        store.dispatch("getUser").then(res => {
          let userInfo = registrationstore.state.userInfo;
          if(!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          } else if (localStorage.getItem("kitid") && localStorage.getItem("kitid").length > 10 && localStorage.getItem("kitid") != 'activate') {
            next("/home/kit/"+localStorage.getItem("kitid"));
          } else {
            next();
          }
        });
      } else if (sessionStorage.getItem("ctoken")) {
        store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        store.commit("back", false);
        store.commit("setDetails",false);
        store.dispatch("getUser").then(res => {
          let userInfo = registrationstore.state.userInfo;
          if(!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          } else if (sessionStorage.getItem("kitid") && localStorage.getItem("kitid").length > 10 && sessionStorage.getItem("kitid") != 'activate') {
            next("/home/kit/"+sessionStorage.getItem("kitid"));
          } else {
            next();
          }
        });
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/home/kit/:id",
    component: ProjectInfo,
    name: "ProjectInfo",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("cToken")) {
        store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        store.commit("setDetails",true);
        store.commit("back", false);
        store.dispatch("getUser").then(res => {
          let userInfo = registrationstore.state.userInfo;
          if(!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          } 
          localStorage.removeItem("kitid");
          next();
        });
      } else if (sessionStorage.getItem("ctoken")) {
        store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        store.commit("back", false);
        store.commit("setDetails",true);
        store.dispatch("getUser").then(res => {
          let userInfo = registrationstore.state.userInfo;
          if(!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          } 
          sessionStorage.removeItem("kitid");
          next();
        });
      } else {
        var url = window.location.pathname;
       const id = url.substring(url.lastIndexOf('/') + 1);
        localStorage.setItem("kitid", id);
        sessionStorage.setItem("kitid", id);
        next("/login");
      }
    }
  },
  {
    path: "/download/kit/:kitid",
    component: DownloadReport,
    name: "DownloadReport",
  },
  {
    path: "/verification",
    component: Verification,
    name: "Verification",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("cToken") || sessionStorage.getItem("ctoken")) {
        if (localStorage.getItem("ctoken")) {
          store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        } else {
          store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        }
        store.commit("back", false);
        store.commit("setDetails",false);
        let userInfo = registrationstore.getters.userInfo;
        if(Object.values(userInfo).length === 0){
          store.dispatch("getUser").then(res => {
            next();
          });
        } else {
          next();
        }
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/home-v2",
    component: V2Dashboard,
    name: "HomeV2",
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("ctoken") || sessionStorage.getItem("ctoken");
      if (token) {
        if (localStorage.getItem("ctoken")) {
          store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        } else {
          store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        }
        store.commit("back", false);
        store.commit("setDetails", false);
        store.dispatch("getUser").then(() => {
          let userInfo = registrationstore.state.userInfo;
          if (!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          } else {
            next();
          }
        });
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/home-v2/kit/:id",
    component: V2ProjectInfo,
    name: "V2ProjectInfo",
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem("ctoken") || sessionStorage.getItem("ctoken");
      if (token) {
        if (localStorage.getItem("ctoken")) {
          store.dispatch("setCustomerToken", localStorage.getItem("ctoken"));
        } else {
          store.dispatch("setCustomerTokenSession", sessionStorage.getItem("ctoken"));
        }
        store.commit("back", false);
        store.commit("setDetails", true);
        store.dispatch("getUser").then(() => {
          let userInfo = registrationstore.state.userInfo;
          if (!userInfo.confirmed_email && !userInfo.confirmed_phone) {
            next("/verification");
          }
          next();
        });
      } else {
        next("/login");
      }
    }
  },
  {
    path: "*",
    name: "404",
    redirect: "/"
  }
];
